module.exports = __webpack_public_path__ + "img/CECA_DC.e0e86dd3.png";